var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-card",
        [
          _c("g-breadcrumb", {
            attrs: { paginas: _vm.paginaStatus.caminhoMigalha }
          }),
          _c("tela-monitora", {
            ref: "refTelaMonitora",
            attrs: { paginaStatus: _vm.paginaStatus }
          }),
          _c(
            "q-card-main",
            [
              _c(
                "q-card",
                {
                  staticStyle: { width: "300px", height: "120px" },
                  attrs: { inline: "", color: "green" }
                },
                [
                  _c(
                    "q-item",
                    [
                      _c(
                        "q-item-side",
                        [
                          _c("q-item-tile", {
                            attrs: { color: "white", icon: "fas fa-calendar" }
                          })
                        ],
                        1
                      ),
                      _c(
                        "q-item-main",
                        [
                          _c("q-item-tile", { attrs: { label: "" } }, [
                            _vm._v("Processos abertos hoje")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-card-title",
                    [
                      _c("q-btn", {
                        staticClass: "full-width text-right mrg-t-20",
                        staticStyle: { color: "#fff" },
                        attrs: {
                          align: "right",
                          flat: "",
                          label: _vm.qtdProcessosAbertoHoje
                        },
                        on: { click: _vm.pesquisarAbertosHoje }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "q-card",
                {
                  staticStyle: { width: "300px", height: "120px" },
                  attrs: { inline: "", color: "orange" }
                },
                [
                  _c(
                    "q-item",
                    [
                      _c(
                        "q-item-side",
                        [
                          _c("q-item-tile", {
                            attrs: {
                              color: "white",
                              icon: "fas fa-globe-americas"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "q-item-main",
                        [
                          _c("q-item-tile", { attrs: { label: "" } }, [
                            _vm._v(
                              "Solicitações via internet que viraram processo"
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-card-title",
                    [
                      _c("q-btn", {
                        staticClass: "full-width text-right",
                        staticStyle: { color: "#fff", "margin-top": "5px" },
                        attrs: {
                          align: "right",
                          flat: "",
                          label: _vm.qtdSolicitacaoProcesso
                        },
                        on: { click: _vm.pesquisarSolicitacaoProcesso }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "q-card",
                {
                  staticStyle: { width: "300px", height: "120px" },
                  attrs: { inline: "", color: "blue" }
                },
                [
                  _c(
                    "q-item",
                    [
                      _c(
                        "q-item-side",
                        [
                          _c("q-item-tile", {
                            attrs: {
                              color: "white",
                              icon: "fas fa-folder-open"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "q-item-main",
                        [
                          _c("q-item-tile", { attrs: { label: "" } }, [
                            _vm._v("Processos abertos via balcão")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-card-title",
                    [
                      _c("q-btn", {
                        staticClass: "full-width text-right mrg-t-20",
                        staticStyle: { color: "#fff" },
                        attrs: {
                          align: "right",
                          flat: "",
                          label: _vm.qtdProcessosAbertoViaBalcao
                        },
                        on: { click: _vm.pesquisarViaBalcao }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-sm-2 col-xs-2" },
                  [
                    _c("g-input", {
                      ref: "refNumProcessoInicial",
                      attrs: {
                        id: "refNumProcessoInicial",
                        name: "refNumProcessoInicial",
                        validacao: "Number",
                        mascara: "numero",
                        tamanho: 10,
                        etiqueta: "Nº do processo",
                        foco: false
                      },
                      model: {
                        value: _vm.aberturaProcesso.numProcesso,
                        callback: function($$v) {
                          _vm.$set(_vm.aberturaProcesso, "numProcesso", $$v)
                        },
                        expression: "aberturaProcesso.numProcesso"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-sm-2 col-xs-2" },
                  [
                    _c("g-input", {
                      ref: "refTxtProcesso",
                      attrs: {
                        id: "refTxtProcesso",
                        name: "refTxtProcesso",
                        validacao: "Number",
                        tamanho: 40,
                        etiqueta: "Nota Fiscal",
                        foco: false
                      },
                      model: {
                        value: _vm.aberturaProcesso.txtNotaFiscal,
                        callback: function($$v) {
                          _vm.$set(_vm.aberturaProcesso, "txtNotaFiscal", $$v)
                        },
                        expression: "aberturaProcesso.txtNotaFiscal"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-sm-8 col-xs-8" },
                  [
                    _c("g-autocomplete", {
                      ref: "refRequerente",
                      attrs: {
                        id: "refRequerente",
                        name: "refRequerente",
                        etiqueta: "Requerente",
                        valor: "codRequerente",
                        foco: false,
                        descricaoPrimaria: "nomeDataNascimentoDocumento",
                        desabilitar: _vm.paginaStatus.desabilitarEdicao,
                        api: _vm.apiRequerente
                      },
                      model: {
                        value: _vm.aberturaProcesso.requerente.codRequerente,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.aberturaProcesso.requerente,
                            "codRequerente",
                            $$v
                          )
                        },
                        expression: "aberturaProcesso.requerente.codRequerente"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-sm-6 col-xs-6" },
                  [
                    _c("g-autocomplete", {
                      ref: "refAssunto",
                      attrs: {
                        id: "refAssunto",
                        name: "refAssunto",
                        etiqueta: "Assunto",
                        valor: "codAssunto",
                        descricaoPrimaria: "desAssunto",
                        api: _vm.apiAssunto
                      },
                      model: {
                        value: _vm.codAssunto,
                        callback: function($$v) {
                          _vm.codAssunto = $$v
                        },
                        expression: "codAssunto"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-sm-6 col-xs-6" },
                  [
                    _c("g-autocomplete", {
                      ref: "refSubAssunto",
                      attrs: {
                        id: "refSubAssunto",
                        name: "refSubAssunto",
                        etiqueta: "Subassunto",
                        valor: "codSubassunto",
                        descricaoPrimaria: "desSubassunto",
                        api:
                          _vm.codAssunto !== ""
                            ? _vm.apiSubAssuntoTermo
                            : _vm.apiSubAssunto,
                        filtroAdicional: _vm.getFiltroSubassunto
                      },
                      model: {
                        value: _vm.codSubassunto,
                        callback: function($$v) {
                          _vm.codSubassunto = $$v
                        },
                        expression: "codSubassunto"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "col-6 text-left mrg-t-10" },
                [
                  _c(
                    "q-btn",
                    {
                      staticStyle: {
                        background: "#550059 !important",
                        color: "white"
                      },
                      attrs: { icon: "fa fa-search" },
                      on: { click: _vm.pesquisarTodos }
                    },
                    [_vm._v("\n            Pesquisar\n        ")]
                  ),
                  _vm._v("\n          \n        "),
                  _c(
                    "q-btn",
                    {
                      attrs: { icon: "fa fa-eraser" },
                      on: { click: _vm.limparFiltros }
                    },
                    [_vm._v("\n            Limpar\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("g-datatable", {
        ref: "refResultadoPesquisaAberturaProcesso",
        attrs: {
          id: "refResultadoPesquisaAberturaProcesso",
          name: "refResultadoPesquisaAberturaProcesso",
          colunas: _vm.colunasAberturaProcessoDataTable,
          operacoes: _vm.operacoes,
          api: _vm.apiaberturaProcesso,
          getFiltroPesquisa: _vm.getFiltroPesquisa,
          elementosPorPagina: _vm.elementosPorPagina,
          exibirColunaOperacoes: true,
          carregamentoInicial: false,
          scrollHorizontal: false
        },
        model: {
          value: _vm.pagina,
          callback: function($$v) {
            _vm.pagina = $$v
          },
          expression: "pagina"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }